import { QueryClient } from '@tanstack/react-query'

/**
 * App-wide TanStack Query client.
 * Lives in its own module (rather than App.tsx) so non-component code —
 * notably the auth listener — can clear it when the signed-in user changes.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
})
